// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__phCL0","right":"styles_right__2DphH"};